import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
} from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { IPackage } from '@models';

@Component({
    selector: 'ui-nuget-viewer',
    templateUrl: './nuget-viewer.modal.html',
    styleUrls: ['./nuget-viewer.modal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation : ViewEncapsulation.None,
})
export class NugetViewerModalComponent extends UiModalComponent<IPackage> {

    /**
     * This method gets called on delete and close event.
     */
    public onClose() {
        this._dialogRef.close();
    }
}
